import React, { useState } from "react";
import "../../../css/View/SummaryElements.css";
import { getTotalParticipants } from "../../../utils/VariantRegistrationsUtils";
import Element from "../../AddTripForm/Elements/Element";

const SummaryElements = ({ variant, registrations, elements, allVariants, onUpdated }) => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [clickedElement, setClickedElement] = useState(null);

  const total = getTotalParticipants(registrations);
  const limit = variant.capacity ?? "-";
  const taken = limit !== "-" ? total : "-";

  const getSharedVariants = (element) => {
    const others = allVariants.filter(
      (v) => v.guid !== variant.guid && element.variants.includes(v.guid)
    );
    return others.length > 0 ? others.map((v) => v.name).join(", ") : "-";
  };

  const groupElementsByDate = (elements) => {
    const grouped = {};
    const sorted = [...elements].sort((a, b) => {
      const ta = a.startDate ? new Date(a.startDate).getTime() : Number.POSITIVE_INFINITY;
      const tb = b.startDate ? new Date(b.startDate).getTime() : Number.POSITIVE_INFINITY;
      return ta - tb;
    });

    sorted.forEach((el) => {
      const date = el.startDate ? el.startDate.split("T")[0] : "Brak daty";
      if (!grouped[date]) grouped[date] = [];
      grouped[date].push(el);
    });

    return grouped;
  };

  const openEdit = (el) => {
    setClickedElement(el);
    setIsEditOpen(true);
  };

  const closeEdit = () => {
    setIsEditOpen(false);
    setClickedElement(null);
  };

  const handleSavedOrDeleted = async () => {
    closeEdit();
    await onUpdated?.();
  };

  return (
    <div className="summary-elements-container">
      <h3>Zajętość elementów wariantu</h3>

      <div className="summary-elements-info">
        <div>
          <strong>Zajętość wariantu:</strong> {taken}/{limit}
        </div>
      </div>

      <div className="summary-elements-scroll">
        <table className="summary-elements-table">
          <thead>
            <tr>
              <th>Elementy wariantu</th>
              <th>Pojemność</th>
              <th>Współdzielony z</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(groupElementsByDate(elements)).map(([date, els]) => (
              <React.Fragment key={date}>
                <tr className="day-header">
                  <td colSpan="3">
                    📅 {date}
                  </td>
                </tr>

                {els.map((el, idx) => (
                  <tr
                    key={el.guid ?? `${date}-${idx}`}
                    className="summary-clickable-row"
                    onClick={() => openEdit(el)}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") openEdit(el);
                    }}
                    title="Kliknij aby edytować element"
                  >
                    <td>{el.name}</td>
                    <td>{el.capacity ?? "-"}</td>
                    <td>{getSharedVariants(el)}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {isEditOpen && clickedElement && (
        <div className="popup">
          <div className="popupContent nicePopup summary-edit-modal">
            <Element
              initialData={clickedElement}
              variantGuid={variant.guid}
              onSave={handleSavedOrDeleted}
              onDelete={handleSavedOrDeleted}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default SummaryElements;
